interface PromoCardProps {
  badge?: string;
  title: string;
  description: string;
  ctaText: string;
  ctaHref: string;
  theme: "pots" | "healthcare";
}

export function PromoCard({
  badge,
  title,
  description,
  ctaText,
  ctaHref,
  theme,
}: PromoCardProps) {
  return (
    <div class={`promo-card promo-card-${theme}`}>
      <div class="promo-card-content">
        {badge && <span class="promo-card-badge">{badge}</span>}
        <h3 class="promo-card-title">{title}</h3>
        <p class="promo-card-description">{description}</p>
        <a href={ctaHref} class="promo-card-cta">
          {ctaText}
          <span class="arrow-icon">→</span>
        </a>
      </div>
    </div>
  );
}
